



























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Button from '@/components/common/inputs/Button.vue';
import Well from '@/components/common/Well.vue';
import AttachmentComponent from './Attachment.vue';
import { Attachment, AttachmentFile } from '@/store/modules/processInterfaces';
import { ProcessModule } from '@/store/modules/process';

@Component({
  components: {
    AttachmentComponent,
    Button,
    Well
  }
})
export default class AttachmentUpload extends Vue {
  idCounter = 0;
  placeholders: AttachmentFile[] = [];
  isUploading = false;
  maxFileSize = 10000000;

  @Prop(Boolean)
  disabled!: boolean;

  get visibleForAll() {
    return ProcessModule.attachments?.filter(att => att.visibleToOtherMunicipalities);
  }

  get visibleForMunicipality() {
    return ProcessModule.attachments?.filter(att => !att.visibleToOtherMunicipalities);
  }

  chooseFiles(files: FileList) {
    Array.from(files).forEach(file => {
      this.placeholders.push({
        fileName: file.name,
        file,
        visibleToOtherMunicipalities: false,
        id: this.idCounter++
      });
    });

    this.clearFileInput();
  }

  clearFileInput() {
    const input = this.$refs.fileInput as HTMLInputElement;
    input.type = 'text';
    input.type = 'file';
  }

  async uploadFiles() {
    this.isUploading = true;

    const { valid, invalid } = this.placeholders.reduce(
      (files: { valid: AttachmentFile[]; invalid: AttachmentFile[] }, file) => {
        file.file.size < this.maxFileSize ? files.valid.push(file) : files.invalid.push(file);
        return files;
      },
      { valid: [], invalid: [] }
    );

    await ProcessModule.uploadAttachments(valid);

    this.isUploading = false;
    this.placeholders = invalid;
  }

  removeAttachment(id: number) {
    if (!confirm('よろしいですか？')) {
      return;
    }

    ProcessModule.removeAttachment(id);
  }
  removePlaceholder(id: number) {
    if (!confirm('よろしいですか？')) {
      return;
    }

    this.placeholders = this.placeholders.filter(placeholder => placeholder.id !== id);
  }
}
